import { render, staticRenderFns } from "./SelectColorModal.vue?vue&type=template&id=d88448ee&scoped=true&"
import script from "./SelectColorModal.vue?vue&type=script&lang=js&"
export * from "./SelectColorModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectColorModal.vue?vue&type=style&index=0&id=d88448ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88448ee",
  null
  
)

export default component.exports